import { useTranslation } from "react-i18next";
import { SwapOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import copy from "copy-to-clipboard";
import { Dialog } from "react-vant";
import { Image, Upload } from "antd";
import { Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import QRCode from "qrcodejs2";
import { imageConfig } from "../../../../config/config";

export default function CenterPage({
  coinList,
  sendRecharge,
  use,
  setUse,
  coinPriceData,
}) {
  const navigate = useNavigate();
  const [addrId, setAddrId] = useState(0);
  const [img, setImg] = useState("");
  const [num, setNum] = useState("");
  const { t: translate } = useTranslation();
  let qrcode = null;

  //上传
  const handleChange = (info) => {
    if (info.file.status === "done") {
      if (info.file.response && info.file.response.ok) {
        Toast.show({
          content: `${info.file.name} ${translate(getText("上傳成功"))}`,
        });
        const data = info.file.response;
        setImg(data.data);
      } else {
        Toast.show({ content: translate(getText("上传失败")) });
      }
    } else if (info.file.status === "error") {
      Toast.show({ content: translate(getText("上传失败")) });
    }
  };

  const creatQrCode = () => {
    let text = use?.czaddress;
    document.getElementById("qrcode").innerHTML = "";
    qrcode = new QRCode(document.getElementById("qrcode"), {
      text: text, //二维码内容字符串
      width: 100, //图像宽度
      height: 100, //图像高度
      colorDark: "#000000", //二维码前景色
      colorLight: "#ffffff", //二维码背景色
      correctLevel: QRCode.CorrectLevel.H, //容错级别
    });
  };

  const handleCopy = (value) => {
    if (copy(value)) {
      Toast.show({ content: translate(getText("成功")) });
    }
  };
  useEffect(() => {
    creatQrCode();
  }, [use]);
  return (
    <div className="bg-neutral-900 min-h-screen w-full text-neutral-200">
      <div className="max-w-lg mx-auto px-4 py-6 animate-fade-in">
        {/* QR Code Section */}
        <div className="flex flex-col items-center justify-center mb-6">
          <div className="bg-neutral-800 p-6 rounded-xl shadow-lg">
            <div className="relative mb-2">
              <div className="bg-white p-2 rounded-lg">
                <div className="relative w-[130px] h-[130px]">
                  <div className="qrcodeiconDiv w-full h-full">
                    <div className="qrcodeiconDiv1 absolute top-0 left-0 w-3 h-3 border-t-2 border-l-2 border-primary"></div>
                    <div className="qrcodeiconDiv2 absolute top-0 right-0 w-3 h-3 border-t-2 border-r-2 border-primary"></div>
                    <div className="qrcodeiconDiv3 absolute bottom-0 left-0 w-3 h-3 border-b-2 border-l-2 border-primary"></div>
                    <div className="qrcodeiconDiv4 absolute bottom-0 right-0 w-3 h-3 border-b-2 border-r-2 border-primary"></div>
                    <div id="qrcode" className="flex items-center justify-center w-full h-full"></div>
                  </div>
                </div>
              </div>
            </div>
            <button className="bg-primary hover:bg-primary-light text-black font-medium rounded-full py-2 px-6 text-sm transition-all duration-300 w-full">
              {translate(getText("保存二維碼"))}
            </button>
          </div>
        </div>

        {/* Address Section */}
        <div className="bg-neutral-800/80 rounded-xl p-5 mb-6 shadow-lg">
          <div className="text-center mb-4">
            <h3 className="text-white font-medium mb-2">{translate(getText("充幣地址"))}</h3>
            <p className="text-sm text-neutral-300 break-all bg-neutral-900/50 p-3 rounded-lg">
              {use?.czaddress}
            </p>
          </div>
          <button 
            onClick={() => handleCopy(use?.czaddress)}
            className="border border-primary text-primary hover:bg-primary/10 font-medium rounded-full py-2 px-6 text-sm transition-all duration-300 w-full"
          >
            {translate(getText("複製地址"))}
          </button>
        </div>

        {/* Recharge Form */}
        <div className="bg-neutral-800/80 rounded-xl p-5 mb-6 shadow-lg">
          <div className="space-y-6">
            {/* Amount Input */}
            <div className="mb-5">
              <label className="block text-sm text-neutral-300 mb-2">
                {translate(getText("充幣數量"))}({use?.name?.toUpperCase()})
              </label>
              <div className="bg-neutral-900/50 rounded-lg overflow-hidden flex items-center">
                <input
                  type="number"
                  id="usdtmoney"
                  name="usdtmoney"
                  autoComplete="off"
                  value={num}
                  onChange={(e) => {
                    if (e.target.value === "") {
                      setNum("");
                    }
                    if (/^[0-9]+(\.[0-9]{0,5})?$/.test(e.target.value)) {
                      setNum(e.target.value);
                    }
                  }}
                  className="w-full bg-transparent px-4 py-3 text-white focus:outline-none"
                />
              </div>
            </div>

            {/* Conversion Section */}
            {coinPriceData?.close != undefined && (
              <>
                <div className="flex justify-center my-2">
                  <div className="bg-neutral-700 rounded-full p-1">
                    <SwapOutlined
                      style={{
                        transform: "rotate(90deg)",
                        color: "#8B5CF6",
                        fontSize: 16,
                        padding: "4px",
                      }}
                    />
                  </div>
                </div>
                <div className="mb-5">
                  <label className="block text-sm text-neutral-300 mb-2">
                    {translate(getText("转化數量"))}(USDT)
                  </label>
                  <div className="bg-neutral-900/50 rounded-lg overflow-hidden flex items-center">
                    <input
                      disabled
                      type="number"
                      id="usdtmoney"
                      name="usdtmoney"
                      autoComplete="off"
                      value={
                        Number(num) && coinPriceData?.close
                          ? (Number(num) * Number(coinPriceData?.close)).toFixed(2)
                          : coinPriceData?.close == undefined
                            ? num || 0
                            : num
                              ? "..."
                              : 0
                      }
                      className="w-full bg-transparent px-4 py-3 text-neutral-100 focus:outline-none cursor-not-allowed"
                    />
                  </div>
                </div>
              </>
            )}

            {/* Upload Section */}
            <div className="mb-5">
              <label className="block text-sm text-neutral-300 mb-2">
                {translate(getText("上傳支付詳情截圖"))}
              </label>
              <div className="flex justify-center">
                <Upload
                  name="file"
                  listType="picture-card"
                  accept="image/*"
                  showUploadList={false}
                  action={imageConfig.uploadUrl}
                  onChange={handleChange}
                  className="upload-wrapper"
                >
                  <div className="w-full h-full flex items-center justify-center border-2 border-dashed border-neutral-600 rounded-lg p-2 bg-neutral-900/30 hover:border-primary transition-all duration-300">
                    {img ? (
                      <Image
                        preview={false}
                        style={{
                          maxHeight: "100px",
                          maxWidth: "100px",
                        }}
                        src={imageConfig.baseImageUrl + img}
                        fallback=""
                      />
                    ) : (
                      <div className="text-center text-neutral-400">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mx-auto mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <p className="text-xs">{translate(getText("點擊上傳圖片"))}</p>
                      </div>
                    )}
                  </div>
                </Upload>
              </div>
            </div>

            {/* Submit Button */}
            <button
              className={`w-full bg-gradient-primary hover:opacity-90 text-black font-medium rounded-full py-3 px-6 transition-all duration-300 ${
                !num ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={() => {
                if (!num) {
                  return;
                }
                if (
                  coinPriceData?.close != undefined &&
                  !coinPriceData?.close
                ) {
                  return;
                }
                sendRecharge({
                  coinname: use.name,
                  czaddress: use.czaddress,
                  payimg: img,
                  currenyNum: num,
                  currenyName: use?.name?.toUpperCase(),
                  zznum:
                    Number(num) && coinPriceData?.close
                      ? Number(num) * Number(coinPriceData?.close)
                      : num,
                  czline: use.czline,
                });
                setNum("");
                setImg("");
              }}
            >
              {translate(getText("提交"))}
            </button>
          </div>
        </div>
        
        {/* Bottom Spacer */}
        <div className="h-20"></div>
      </div>
    </div>
  );
}
